import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useContainerMediaQueriesChecks} from "../../hooks/use-container-media-queries-checks.hook";
import {SearchMaskWebappSmallScreenComponent} from "./webapp/small-screen/search-mask.webapp.small-screen.component";
import {SearchMaskWebappLageScreenComponent} from "./webapp/large-screen/search-mask.webapp.lage-screen.component";

export const SearchMaxBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

export const SearchMaskComponent: React.FC = observer(() => {
    const containerMediaQuery = useContainerMediaQueriesChecks();
    return (
        <SearchMaxBox>
            {containerMediaQuery.mAndBelow ? <SearchMaskWebappSmallScreenComponent/> :  <SearchMaskWebappLageScreenComponent/>}
        </SearchMaxBox>
    );
})
